import type {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  ReactElement,
} from 'react';

export type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export type IconElement = ReactElement<{ className?: string }>;

export const classes = {
  buttonBase:
    'rounded-full transition-colors h-8 w-8 flex items-center justify-center',
  iconBase: 'transition-colors',
  button: 'bg-transparent',
  icon: 'text-xl text-grey-6 hover:text-grey-8',
  buttonFilled: 'bg-grey-6 hover:bg-grey-8',
  iconFilled: 'text-lg text-white',
};
